import type { ComponentsPropsList } from '@mui/material/styles';

import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiChip: {
      styleOverrides: {
        root: { gap: 4, borderRadius: 50, '&.Mui-disabled': { opacity: 1 } },
        label: ({ theme: { unstable_sx: sx } }) => sx({ p: 0 }),
        outlined: ({ theme, ownerState }) => {
          const color = ownerState?.color as ComponentsPropsList['MuiChip']['color'];
          let colorStyle = {};
          if (color && color !== 'default') {
            colorStyle = {
              color: theme.palette[color ?? 'primary'].main,
              borderColor: theme.palette[color ?? 'primary'].light,
              backgroundColor: theme.palette[color ?? 'primary'].lighter,
            };
          }
          return { fontWeight: 600, ...colorStyle };
        },
        filled: ({ theme, ownerState }) => {
          const color = ownerState?.color;
          const isClickable = ownerState?.clickable;
          const isDisabled = ownerState?.disabled;

          let colorStyle = {};
          if (color && color !== 'default') {
            colorStyle = {
              backgroundColor: isDisabled
                ? theme.palette[color ?? 'primary'].light
                : theme.palette[color ?? 'primary'].lighter,
              color: isDisabled
                ? theme.palette.text.disabled
                : theme.palette[color ?? 'primary'].main,
              ':hover': {
                backgroundColor: isClickable ? theme.palette[color ?? 'primary'].light : undefined,
              },
            };
          } else {
            colorStyle = {
              color: isDisabled ? theme.palette.text.disabled : theme.palette.text.primary,
              backgroundColor: isDisabled ? theme.palette.grey[200] : theme.palette.grey[100],
              ':hover': {
                backgroundColor: isClickable ? theme.palette.grey[200] : undefined,
              },
            };
          }

          return {
            ...theme.typography.caption,
            ...colorStyle,
          };
        },
        sizeSmall: ({ theme: { unstable_sx: sx }, ownerState }) => {
          const hasStartAdornment = ownerState?.avatar || ownerState?.icon;

          if (hasStartAdornment) {
            return sx({ p: theme.spacing(0.25, 0.5, 0.25, 0.25) });
          }

          return sx({ px: 1, py: 0.25 });
        },
        sizeMedium: ({ theme: { unstable_sx: sx } }) => sx({ px: 2, py: 0.25 }),
        deleteIcon: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({ color: theme.palette.grey[500], m: 0 }),
        avatar: ({ theme: { unstable_sx: sx } }) => sx({ m: 0 }),
      },
    },
  },
});

export default theme.components;
